<script>
export default {
  name: 'CtaNeedPremium',

  props: {
    url: String,
  },

  methods: {
    openNeedPremiumModal() {
      this.$root.openNeedPremiumPopup({
        accomodationsUrl: this.url,
      })
    },
  },
}
</script>

<template>
  <button
    class="btn mb-4 w-full border border-secondary bg-white text-xs font-semibold text-secondary md:mb-0 md:w-auto"
    @click="openNeedPremiumModal">
    {{ $t('buttons.bookAccommodation') }}
  </button>
</template>
